import RoleAccessCard from "./RoleAccessCard";
import PermissionsCard from "./PermissionsCard";
import TeamMembersCard from "./TeamMembersCard";
import styles from "../../../../pages/ClientDashboard/Profile/profile.module.css";

export default function AccessRoleTab({
  data,
  onShowToast,
  getCompanyProfile,
}) {
  return (
    <div className={styles.contentGrid}>
      <div className={styles.contentMain}>
        <RoleAccessCard
          data={data}
          onShowToast={onShowToast}
          getCompanyProfile={getCompanyProfile}
        />
        <PermissionsCard />
      </div>
      <div className={styles.contentSide}>
        <TeamMembersCard />
      </div>
    </div>
  );
}
